/**
 * Record to add analytics to product card buttons.
 */
const PRODUCT_ANALYTICS = {
    "autoprotect": "Автозахист",
    "tourism": "Туризм",
    "green-card": "Зелена картка",
    "oscpv": "Автоцивілка",
    "strakhuvannia-mayna": "Майно"
} as Record<string, string>

const PRODUCT_EVENT_ANALYTICS = {
    "autoprotect": "product_select_autoprotect",
    "tourism": "product_select_tourism",
    "green-card": "product_select_gc",
    "oscpv": "product_select_osago",
    "strakhuvannia-mayna": "product_select_mayno"
} as Record<string, string>

export { PRODUCT_ANALYTICS, PRODUCT_EVENT_ANALYTICS }
